import React from 'react';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { LoadingSpinner } from '../LoadingSpinner';

const LazyRequestListPage = React.lazy(() => import('./RequestList'));
export const AsyncRequestListPage: React.FC<{ piletApi: PiletApi }> = props => {
	return (
		<React.Suspense fallback={<LoadingSpinner />}>
			<LazyRequestListPage {...props} />
		</React.Suspense>
	);
};

const LazyRequestListsPage = React.lazy(() => import('./RequestLists'));
export const AsyncRequestListsPage: React.FC<{ piletApi: PiletApi }> = props => {
	return (
		<React.Suspense fallback={<LoadingSpinner />}>
			<LazyRequestListsPage {...props} />
		</React.Suspense>
	);
};

const LazyDemoPage = React.lazy(() => import('./Demo'));
export const AsyncDemoPage: React.FC<{ piletApi: PiletApi }> = props => {
	return (
		<React.Suspense fallback={<LoadingSpinner />}>
			<LazyDemoPage {...props} />
		</React.Suspense>
	);
};
